import { render, staticRenderFns } from "./LevelDemo.vue?vue&type=template&id=94e236be&scoped=true"
import script from "./LevelDemo.vue?vue&type=script&lang=js"
export * from "./LevelDemo.vue?vue&type=script&lang=js"
import style0 from "./LevelDemo.vue?vue&type=style&index=0&id=94e236be&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e236be",
  null
  
)

export default component.exports